'use client'
import { useAIFeatureEnableManager } from '@/src/hooks/AIFeatureEnableManager'
import { RecentSearchListItem } from '@/src/hooks/srp/recentSearch'
import { useFeatures } from '@/src/hooks/useFeatures'
import { HOLIDAYS_NAV_PATH } from '@/src/utils/holidays'
import { useRouter } from '@/src/i18n/navigation'
import { useLocale, useTranslations } from 'next-intl'
import { useState } from 'react'
import { FlightSearchTabs as FlightSearchTabsComponent } from './flightSearchTabs'

interface FlightSearchTabsProps {
    isMobile: boolean
    serverRecentSearches: RecentSearchListItem[]
    hideMulticity?: boolean
    fromParam?: any[] | null
    toParam?: any[] | null
    showVisaTab?: boolean
    showFlightsHotelsTab?: boolean
    showHolidaysTab?: boolean
    initialAiEnabled?: boolean
}

export const FlightSearchTabs = ({
    isMobile,
    serverRecentSearches,
    hideMulticity,
    fromParam,
    toParam,
    showVisaTab = false,
    showFlightsHotelsTab = false,
    showHolidaysTab = false,
    initialAiEnabled
}: FlightSearchTabsProps) => {
    const { homeAISearch } = useAIFeatureEnableManager(initialAiEnabled)
    const showAiSearchTab = homeAISearch
    const { EXPERIENCE } = useFeatures()
    const showExperienceTab = !!EXPERIENCE
    const showThirdTab = showVisaTab || showFlightsHotelsTab
    const flightsTabIndex = 0
    const hotelsTabIndex = flightsTabIndex + 1
    const thirdTabIndex = hotelsTabIndex + 1
    const holidaysTabIndex = showThirdTab ? thirdTabIndex + 1 : thirdTabIndex
    const experienceTabIndex = showHolidaysTab ? holidaysTabIndex + 1 : holidaysTabIndex

    const [tabValue, setTabValue] = useState(0)
    const locale = useLocale()
    const t = useTranslations('header')
    const router = useRouter()

    const handleTabChange = (newValue: number) => {
        if (newValue === hotelsTabIndex) {
            // Internal route on both brands — next-intl adds the active locale prefix.
            router.push('/hotels')
        } else if (showThirdTab && newValue === thirdTabIndex) {
            const thirdHref = showVisaTab ? '/visa' : `/${locale}/flights-hotels`
            window.location.href = thirdHref
        } else if (showHolidaysTab && newValue === holidaysTabIndex) {
            router.push(HOLIDAYS_NAV_PATH)
        } else if (showExperienceTab && newValue === experienceTabIndex) {
            router.push('/experience')
        } else {
            setTabValue(newValue)
        }
    }

    return (
        <FlightSearchTabsComponent
            t={t}
            tabValue={tabValue}
            onTabChange={handleTabChange}
            isMobile={isMobile}
            serverRecentSearches={serverRecentSearches}
            hideMulticity={hideMulticity}
            fromParam={fromParam}
            toParam={toParam}
            showVisaTab={showVisaTab}
            showFlightsHotelsTab={showFlightsHotelsTab}
            showHolidaysTab={showHolidaysTab}
            showExperienceTab={showExperienceTab}
            showAiSearchTab={showAiSearchTab}
        />
    )
}
